<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center" style="margin-top: 4em;">This is for India Grey, Natalie Rivers<br/>and Heidi Rice—I couldn’t do this job without any of<br/>you, and it wouldn’t be half as much fun. Thank you.</p>
<p class="center">(My phone company also extends its thanks<br/>for keeping them in business.)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460346396_epub_ded_r1.vue?15e3655c